<template>
    <div>
        <MenuAccount/>
        <AccountRetrospectList/>
    </div>
</template>

<script>

import MenuAccount from '@/components/menuadmin/account/accountheader/MenuAccount.vue'
import AccountRetrospectList from '@/components/menuadmin/account/accountcreate/AccountRetrospectList.vue'
export default {
    name:'accountRetrospect',
    components:{
        MenuAccount,
        AccountRetrospectList,
    },
}
</script>